<!--我的公司资料-->
<template >
	<div class="home-main company clearfix">
		<div class="main_title">
			<span class="title-cn">公司信息</span>
			<span class="title-en">/Company Information</span>
		</div>
		<div class="main-container"  v-loading="loading">
			<el-scrollbar style="height:100%">
				<el-form :model="companyForm" ref="companyForm" :rules="companyRules" :label-position="labelPosition" class="chang_company">

					<el-form-item label="代理商注册信息修改" label-width="800px" class="chang_title">
					</el-form-item>
					<el-form-item label="代理名称" prop="name" label-width="200px">
						<el-input v-model="companyForm.name" type="text" auto-complete="off" placeholder="请填写代理名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="所在地市" prop="city" :label-width="'200px'">
						<el-cascader class="select_address"
							size="large"
							:options="options"
							v-model="areaOptions"
							@change="areaChange">
							</el-cascader>
					</el-form-item>
					<!-- <el-form-item label="所属行业" prop="industry" label-width="200px">
						<el-select v-model="companyForm.industry" placeholder="请选择所属行业" class="select_industry">
							<el-option label="金融" value="shanghai"></el-option>
							<el-option label="计算机" value="beijing"></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item class="pic" label="营业执照照片" prop="certificate" label-width="200px">
						<el-upload
						class="avatar-uploader"
						:headers="headers"
						name="image"
						:action="uploadPath"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="imageUrl" :src="imageUrl" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
						<!-- <el-input v-model="companyForm.certificate" type="text" auto-complete="off"></el-input> -->
					</el-form-item>
					<el-form-item label="企业负责人信息修改" label-width="800px" class="chang_title">
					</el-form-item>
					<el-form-item label="总经理/CEO" prop="ceo_name" label-width="200px">
						<el-input v-model="companyForm.ceo_name" type="text" auto-complete="off" placeholder="请填写总经理/CEO姓名" clearable></el-input>
					</el-form-item>
					<el-form-item label="手机" prop="ceo_mobile" label-width="200px">
						<el-input v-model="companyForm.ceo_mobile" type="text" auto-complete="off" placeholder="请填写总经理手机" clearable></el-input>
					</el-form-item>
					<el-form-item label="电话" prop="ceo_phone" label-width="200px">
						<el-input v-model="companyForm.ceo_phone" type="text" auto-complete="off" placeholder="请填写总经理电话，格式：区号-电话号码，比如010-1234567" clearable></el-input>
					</el-form-item>
					<el-form-item label="邮箱" prop="ceo_email" label-width="200px">
						<el-input v-model="companyForm.ceo_email" type="text" auto-complete="off" placeholder="请填写总经理邮箱" clearable></el-input>
					</el-form-item>
					<el-form-item label="生日" prop="ceo_birthday" label-width="200px">
						<el-input v-model="companyForm.ceo_birthday" type="text" auto-complete="off" placeholder="请填写总经理生日" clearable></el-input>
					</el-form-item>
					<el-form-item label="技术负责人" prop="it_name" label-width="200px">
						<el-input v-model="companyForm.it_name" type="text" auto-complete="off" placeholder="请填写技术负责人姓名" clearable></el-input>
					</el-form-item>
					<el-form-item label="手机" prop="it_mobile" label-width="200px">
						<el-input v-model="companyForm.it_mobile" type="text" auto-complete="off" placeholder="请填写技术负责人手机" clearable></el-input>
					</el-form-item>
					<el-form-item label="电话" prop="it_phone" label-width="200px">
						<el-input v-model="companyForm.it_phone" type="text" auto-complete="off" placeholder="请填写技术负责人电话，格式：区号-电话号码，比如010-1234567" clearable></el-input>
					</el-form-item>
					<el-form-item label="邮箱" prop="it_email" label-width="200px">
						<el-input v-model="companyForm.it_email" type="text" auto-complete="off" placeholder="请填写技术负责人邮箱" clearable></el-input>
					</el-form-item>
					<el-form-item label="生日" prop="it_birthday" label-width="200px">
						<el-input v-model="companyForm.it_birthday" type="text" auto-complete="off" placeholder="请填写技术负责人生日" clearable></el-input>
					</el-form-item>
					<el-button class="primary submit_company" @click="save">保存</el-button>
				</el-form>
			</el-scrollbar>
		</div>
	</div>
</template>

<script>
	import { isvalidPhone,isEmpty } from '../../assets/js/validate'
	import { regionData } from 'element-china-area-data'
	import { updateAgentInfo }  from "@/api/user";
	import { getLog }  from "@/api/log";
	export default {
		data() {
			//手机号验证
			let validPhone = (rule, value, callback) => {
				if(!value) {
					callback(new Error('请输入电话号码'))
				} else if(!isvalidPhone(value)) {
					callback(new Error('请输入正确的11位手机号码'))
				} else {
					callback()
				}
			};

			//固话验证
			let validtelePhone = (rule, value, callback) => {
				// if(value === '') {
				// 	callback(new Error('请输入固话号码'));
				// } else {
					if(value !== '') {
						let reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
						if(!reg.test(value)) {
							callback(new Error('请输入正确格式的固话号码'));
						}
					}
					callback();
				// }
			};

			return {
				options: regionData,
				loading:false,
				uploadPath:process.env.VUE_APP_BASE_API+"/image/",
				imageUrl:'',
				labelPosition: 'left',
				areaOptions:[],//区域
				companyForm:{
					name:'',//代理商名称
					province:'',//省
					city:'',//城市地区
					district:'',//县
					industry:'', //行业
					certificate:'',//营业执照
					ceo_name:'',//ceo姓名
					ceo_mobile:'',//手机
					ceo_phone:'',//固话
					ceo_email:'',
					ceo_birthday:'',
					it_name:'',
					it_mobile:'',
					it_phone:'',
					it_email:'',
					it_birthday:'',
				},
				companyRules: {
					name: [{
						required: true,
						message: '请设置代理名称',
						trigger: 'blur'
					}],
					city: [{
						required: true,
						message: '请设置代理商所在地市',
						trigger: 'blur'
					}],
					industry: [{
						required: true,
						message: '请设置代理商所属行业',
						trigger: 'blur'
					}],
					certificate: [{
						required: true,
						message: '请设置代理商公司营业执照',
						trigger: 'blur'
					}],

					ceo_name: [{
						required: true,
						message: '请设置总经理/CEO姓名',
						trigger: 'blur'
					}],
					ceo_mobile: [{
						required: true,
						trigger: 'blur',
						validator: validPhone
					}],
					ceo_phone: [{
						//required: true,
						trigger: 'blur',
						validator: validtelePhone
					}],
					ceo_email: [{
							required: true,
							message: '请输入联系人邮箱地址',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: 'blur'
						}
					],
					it_name: [{
						required: true,
						message: '请设置技术负责人姓名',
						trigger: 'blur'
					}],
					it_mobile: [{
						required: true,
						trigger: 'blur',
						validator: validPhone
					}],
					it_phone: [{
						//required: true,
						trigger: 'blur',
						validator: validtelePhone
					}],
					it_email: [{
							required: true,
							message: '请输入联系人 邮箱地址',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: 'blur'
						}
					],
				}

			}
		},
		mounted(){
			this.loading = true
			this.$store.dispatch('user/userinfo')
			.then(() => {
				this.loading = false
				if (this.$store.getters.userInfo.agent_info) {//初始值为null
					this.companyForm = this.$store.getters.userInfo.agent_info
					this.imageUrl = this.companyForm.certificate
				}
				this.setArea()
			})
			.catch(() => {
				this.loading = false
			})
		},
		methods: {
			setArea(){//设置地区数组值
				if (!isEmpty(this.companyForm.province)) {
					let temp = [this.companyForm.province, this.companyForm.city, this.companyForm.district]
					this.areaOptions = temp
				}
			},
			areaChange(value){ //设置对应区域代码
				this.companyForm.province = value[0]
				this.companyForm.city = value[1]
				this.companyForm.district = value[2]
				
			},
			save(){
				this.$refs.companyForm.validate(valid => {
					if (valid) {
						this.loading = true
						updateAgentInfo(this.companyForm).then(() =>{
							this.loading = false
							this.$message({
								type: 'success',
								message: '保存成功'
							});
						}).catch(()=>{
							this.loading = false
						})
					}
				})
			},
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw)
				this.companyForm.certificate = res.image
			},
			beforeAvatarUpload(file) {
				// const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 4;

				// if (!isJPG) {
				// this.$message.error('上传图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 4MB!');
				}
				return isLt2M;
			}
		},
		computed:{
			headers() {
				return{
					"Authorization": `token ${this.$store.getters.token}`
				}
			}
		}
	}
</script>

<style>
	.company .pic{
		height: 600px !important;
	}
	.company .pic label{
		height: 100%;
	}
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 600px;
		height: 600px;
		line-height: 600px;
		text-align: center;
	}
	.avatar {
		width: 600px;
		height: 600px;
		display: block;
	}
	.chang_company {
		margin-top: 31px;
		margin-left: 41px;
		margin-bottom: 180px;
		width: 800px;
	}
	
	.chang_title .el-form-item__label {
		font-size: 14px !important;
		background-color: #d3e4f4 !important;
	}
	
	.chang_company .el-form-item__label {
		padding-left: 35px;
		line-height: 38px;
		background-color: #f9f9f9;
		border: 1px solid #dcdfe6;
		font-size: 12px;
	}
	
	.chang_company .el-form-item {
		margin-bottom: 0px;
	}
	
	.chang_company .el-form-item .el-form-item__content {
		line-height: normal;
	}
	
	.chang_company .el-form-item.is-success .el-input__inner,
	.chang_company .el-form-item.is-error .el-input__inner {
		border-color: #dcdfe6;
	}
	
	.chang_company .el-input__inner {
		border-radius: 0px;
	}
	
	.chang_company .el-input {
		font-size: 12px;
	}
	
	.select_industry {
		width: 600px;
	}
	
	.select_address {
		width: 600px;
	}
	
	.chang_company .el-form-item__error {
		position: inherit;
		height: 20px;
		line-height: 20px;
		padding-top: 0px;
		padding-bottom: 5px;
	}
	
	.submit_company {
		margin-top: 47px !important;
		margin-left: 697px !important;
		padding: 0px !important;
		width: 103px !important;
		height: 34px !important;
		/*line-height: 34px;*/
		background-color: #3887cc;
		border-radius: 2px;
		border: solid 1px #e5e5e5;
	}
</style>


// WEBPACK FOOTER //
// src/components/my/companyInformation.vue